import React from 'react'
import { Table, Container, Row, Col, Label, Input } from 'reactstrap'
import '../css/QuoteViewController.css'
import {
    queryQuote,
    updateQuote,
} from '../model/request/quotes'
import { formatAsDollarValue, moneyText, dateOffsetText } from '../model/Formatting'
import { JustDate } from '../model/JustDate'
import dateFormat from 'dateformat'
import {
    getMultipleCustomerCompanyInfo
} from '../model/request/customer_info'

class AdminPaymentViewController extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'jobs': [],
            'company_infos': {},
        }
    }

    componentDidMount() {
        this.props.turnOnLoader()

        queryQuote({
            'is_shipped': true,
            'admin_paid': false,
        }).then(
            (quotes) => {
                quotes.map((quote) => {
                    quote.originally_checked =
                        quote.payment_history.map((payment) => payment.admin_paid)
                    return quote
                })
                quotes.sort((lhs, rhs) => {
                    return lhs.customer_name.localeCompare(rhs.customer_name)
                })
                this.setState({
                    'jobs': quotes,
                })
                this.downloadCustomerModels([...new Set(
                    quotes.map((quote) => quote.customer_name),
                )])
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    downloadCustomerModels(customerNames) {
        if (customerNames.length === 0) {
            return
        }
        this.props.turnOnLoader()
        getMultipleCustomerCompanyInfo(customerNames).then(
            (company_infos) => {
                this.setState({
                    'company_infos': company_infos,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    renderLabelBody(label, body) {
        return <>
            <Row>
            <Col><Label
                style={{
                    'fontSize': '18pt',
                    'fontWeight': '400',
                }}
            >{label}</Label>
            </Col>
        </Row>
        <Row>
            {body}
        </Row>
        </>
    }

    renderHeaderLabelAndBody(label, body) {
        return <>
        <Row>
            <Col><Label
                style={{
                    'fontSize': '16pt',
                    'fontWeight': '350',
                }}
            >{label}</Label></Col>
        </Row>
        <Row>
            <Col>{body}</Col>
        </Row>
        </>
    }

    renderInput(varname) {
        return <Input
            type='text'
            value={this.state[varname]}
            onChange={(e) => {
                const newState = {}
                newState[varname] = e.target.value
                this.setState(newState)
            }}
            />
    }

    renderRows() {
        if (Object.keys(this.state.company_infos).length === 0) {
            return <></>
        }

        return this.state.jobs.map((job, jobIndex) => {
            return job.payment_history.map((payment, paymentIndex) => {
                if (job.originally_checked[paymentIndex]) {
                    return <></>
                }
                const dueDate = job.shipped_date.advanceDate(
                    this.state.company_infos[job.customer_name].payment_days,
                )
                const lastDatePaid = job.last_date_paid
                const fromDateForInterest = (dueDate.toDate() < lastDatePaid.toDate())
                    ? lastDatePaid
                    : dueDate

                return <tr>
                    <td><Label>{job.given_id}</Label></td>
                    <td><Label><a href={'/quote/' + job.id} text={job.job_name}>{job.job_name}</a></Label></td>
                    <td><Label><a href={'/customerinformation/' + job.customer_name}>
                        {job.customer_name}</a></Label></td>
                    <td><Label><span text={moneyText(job.total_price)}>{formatAsDollarValue(job.total_price)}</span></Label></td>
                    <td>{(() => {
                        const value = job.totalPayments() + job.amountLeftPlusInterest(fromDateForInterest) -
                            job.total_price
                        return <span text={moneyText(value)}>{formatAsDollarValue(value, true)}</span>
                    })()}</td>
                    <td>{(() => {
                        const value = job.totalPayments() + job.amountLeftPlusInterest(fromDateForInterest)
                        return <span text={moneyText(value)}>{formatAsDollarValue(value, true)}</span>
                    })()}</td>
                    <td><Label><span text={moneyText(job.left_to_pay)}>{formatAsDollarValue(job.left_to_pay)}</span></Label></td>
                    <td><Label><span text={moneyText(payment.payment)}>{formatAsDollarValue(payment.payment)}</span></Label></td>
                    <td><Label><span text={dateOffsetText(payment.date)}>{dateFormat(payment.date.toDateTime(), 'mmmm d, yyyy')}</span></Label></td>
                    <td><Label>{payment.nick_name}</Label></td>
                    <td><Label>{this.state.company_infos[job.customer_name].payment_terms_text}</Label></td>
                    <td><Label><span text={dateOffsetText(dueDate)}>{dateFormat(
                        dueDate.toDateTime(),
                        'mmmm d, yyyy',
                    )}</span></Label></td>
                    <td>
                        <Input
                            type='checkbox'
                            checked={payment.admin_paid}
                            onChange={(e) => {
                                payment.admin_paid = !payment.admin_paid
                                updateQuote({
                                    'id': job.id,
                                    'payment_history': job.payment_history,
                                }).then(
                                    (success) => {

                                    },
                                    (error) => {
                                        this.props.showError(error)
                                    }
                                )
                                this.setState({})
                            }}
                        />
                    </td>
                </tr>
            })
        })
    }

    render() {
        return <Container>
            <Row><Col><Container style={{'overflowX': 'auto'}}><Table>
                <thead>
                    <tr>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Type</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Job Name</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Company</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Invoice Amount</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Interest</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}}>Total Amount</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Amount Left</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Payment Amount</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Payment Date</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Bank</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Terms</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Due Date</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '150px'}}>Has Been Paid</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderRows()}
                </tbody>
            </Table></Container></Col></Row>
        </Container>
    }
}

export default AdminPaymentViewController;
